import {BaseView} from "../core/view"
import DependencyUtil from "../utils/dependencies"
import constants from "./constants"
import { TrackingUtil } from '../utils/tracking'
import slick from "slick-carousel"

export default BaseView.extend({

    el: '.js-magazine-post',
    
    events: {
        'click .js-post-facebook': 'shareOnFacebook',
        'click [data-label]': 'onClickTrackGAEvent'
    },

    initialize: function() {
        if (this.$el.length) {
            this.loadSlickSlider();
            this.loadInstagram();
        }
    },

    loadSlickSlider: function() {
        var gallerySlider = this.$el.find('.js-gallery-slider').slick({
            lazyLoad: 'progressive',
            dots: this.isHOS,
            arrows: true,
            speed: 500,
            adaptiveHeight: true,
            prevArrow: '<button type="button" data-role="none" class="slick-new-inside-prev" aria-label="previous"><svg class="scrollable-button__icon-arrow" viewBox="0 0 50 50"><use xlink:href="#icon-arrow-left"></use></svg>Previous</button>',
            nextArrow: '<button type="button" data-role="none" class="slick-new-inside-next" aria-label="next"><svg class="scrollable-button__icon-arrow" viewBox="0 0 50 50"><use xlink:href="#icon-arrow-right"></use></svg>Next</button>',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: this.isHOS
        });
    },

    shareOnFacebook: function(e) {
    		const urlToShare = this.$el.find(e.currentTarget).data(constants.FB_FEED_URL);
    		var self = this;
    		
    		if(typeof (FB) != 'undefined' && window.fbAsyncInit.hasRun) {
    			self.showFacebookSharingPopup(urlToShare);
    		} else {
    			DependencyUtil.use('facebook', function() {
    	            // asynchronous app initialization
    	            window.fbAsyncInit = function() {
    	                FB.init({
    	                    appId: constants.FACEBOOK_APP_ID,
    	                    version: constants.FACEBOOK_VERSION,
    	                    status: true,
    	                    xfbml: true
    	                });
    	                
    	                self.showFacebookSharingPopup(urlToShare);
    	            };
    	        });
    		}
    },

    showFacebookSharingPopup: function(url) {
        FB.ui({
            method: 'share',
            href: url
        }, function(response) {});
    },

    loadInstagram: function() {
        const instagramWrappers = this.el.querySelectorAll(".js-instagram-embed");

        if (instagramWrappers.length) {
            DependencyUtil.use('instagram');

            let instagramScript = document.createElement("script");
            instagramScript.async = true;
            instagramScript.src = "//www.instagram.com/embed.js";

            document.body.appendChild(instagramScript);
        }
    },

    onClickTrackGAEvent: function(e) {
        const element = this.$el.find(e.currentTarget);
        const label = element.data('label');
        TrackingUtil.throwGAEvent('Post', 'socialshare', label, false);
    },
});
